import { atom, selector } from 'recoil';
import { ProjectState } from '~/src/Project/store';

export enum FilterOptions {
  All = 'all',
  Complete = 'complete',
  Incomplete = 'incomplete',
}

export interface FiltersState {
  projectState?:
    | FilterOptions.All
    | FilterOptions.Complete
    | FilterOptions.Incomplete;
  connectorTypes?: string[];
  fromDate?: string;
  toDate?: string;
  tagNames?: string[];
}

export interface SearchParams {
  limit?: number;
  query?: string;
  filter?: string;
  skip?: number;
}

export const searchStringState = atom<{ value: string }>({
  key: 'FilterProject/searchStringState',
  default: { value: '' },
});

export const filtersState = atom<FiltersState>({
  key: 'FilterProject/filtersState',
  default: {
    projectState: FilterOptions.All,
    connectorTypes: [],
    fromDate: '',
    toDate: '',
  },
});

export const isFilteredProjectsState = atom({
  key: 'FilterProject/isFilteredProjectsState',
  default: false,
});

export const queryFilterSelector = selector({
  key: 'FilterProject/queryFilterSelector',
  get: ({ get }) => {
    const filters = get(filtersState);
    const appliedFilter: {
      projectState?: ProjectState[];
      projectStateNot?: ProjectState[];
      connectorTypes?: string[];
      fromDate?: string;
      toDate?: string;
    } = {};

    if (filters.projectState && filters.projectState !== FilterOptions.All) {
      if (filters.projectState === FilterOptions.Complete) {
        appliedFilter.projectState = [ProjectState.Ready, ProjectState.Done];
      } else {
        appliedFilter.projectStateNot = [ProjectState.Ready, ProjectState.Done];
      }
    }

    const connectorTypes = (filters.connectorTypes || []).map((t) => t.toLowerCase());
    if (connectorTypes.length > 0) {
      appliedFilter.connectorTypes = connectorTypes;
    }

    if (filters?.fromDate) {
      appliedFilter.fromDate = filters.fromDate;
    }

    if (filters?.toDate) {
      appliedFilter.toDate = filters.toDate;
    }

    const tagNames = filters.tagNames || [];
    if (tagNames.length > 0) {
      appliedFilter.tagNames = tagNames;
    }

    return Object.keys(appliedFilter).length > 0 ? appliedFilter : null;
  },
});
